<template>
    <div
        class="app-container clearfix"
        v-loading="openloading"
        element-loading-text="加载中"
        element-loading-background="rgba(0, 0, 0, 0.1)"
    >
        <el-row style="padding-bottom: 15px">
            <el-col :span="24">
                <h3 class="headtitle">基础资料维护</h3>
                <span>基础档案</span>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :span="24">
                <el-card>
                    <el-row>
                        <el-col style="padding: 10px 0 20px">
                            <span class="right-15">所属模块:</span>
                            <el-button
                                v-for="(item, index) in lstBusinessModules"
                                :key="item.moduleName"
                                size="medium"
                                :type="CurrnetIndex == index ? 'primary' : ''"
                                @click="statusSearch(item, index)"
                                >{{ item.moduleName }}</el-button
                            >
                            <el-button
                                size="mini"
                                type="primary"
                                icon="el-icon-plus"
                                class="pull-right"
                                @click="addInfo"
                                >新增</el-button
                            >
                        </el-col>
                    </el-row>

                    <el-table
                        :data="tableData"
                        size="mini"
                        style="width: 100%; margin-top: 10px"
                        border
                    >
                        <el-table-column label="操作" width="200">
                            <template slot-scope="scope">
                                <el-tooltip content="编辑" placement="bottom">
                                    <el-button
                                        type="primary"
                                        icon="el-icon-edit"
                                        circle
                                        @click="editRow(scope.row.basicData.id)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                                <el-tooltip content="删除" placement="bottom">
                                    <el-button
                                        type="danger"
                                        icon="el-icon-delete"
                                        circle
                                        @click="deleteEntity(scope.row.basicData.id)"
                                        size="mini"
                                    ></el-button>
                                </el-tooltip>
                            </template>
                        </el-table-column>
                        <el-table-column prop="name" label="资料名称">
                            <template slot-scope="scope">{{ scope.row.basicData.name }}</template>
                        </el-table-column>
                        <el-table-column prop="name" label="编码">
                            <template slot-scope="scope">{{ scope.row.basicData.code }}</template>
                        </el-table-column>
                        <el-table-column prop="moduleID" label="所属分类">
                            <template slot-scope="scope">{{ scope.row.moduleName }}</template>
                        </el-table-column>
                        <el-table-column prop="finFields" label="财务系统字段">
                            <template slot-scope="scope">{{
                                scope.row.basicData.finFields
                            }}</template>
                        </el-table-column>
                        <el-table-column prop="sourceFields" label="业务系统字段">
                            <template slot-scope="scope">{{
                                scope.row.basicData.sourceFields
                            }}</template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" width="350px">
                            <template slot-scope="scope">{{ scope.row.basicData.remark }}</template>
                        </el-table-column>
                        <el-table-column prop="souceTableName" label="对应表名">
                            <template slot-scope="scope">{{
                                scope.row.basicData.souceTableName
                            }}</template>
                        </el-table-column>
                    </el-table>
                    <pagerBar
                        ref="refPagerBar"
                        :apiURL="basicDataListUrl"
                        :GetData="initData"
                        :queryParam="formInLine"
                        :errorFunc="closeOpenloading"
                    ></pagerBar>
                </el-card>
            </el-col>
        </el-row>
        <el-dialog
            v-el-drag-dialog
            :title="title"
            :visible.sync="dialogVisible"
            width="40%"
            :before-close="handleClose"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
        >
            <el-form label-width="110px" :model="formLabel" :rules="rules" ref="BasicDataEditForm">
                <el-form-item label="资料名称" prop="name">
                    <el-select
                        placeholder="请选择基础资料类别"
                        value-key="id"
                        v-model="formLabel.name"
                        @change="changeValue"
                        class="width100"
                    >
                        <el-option
                            v-for="item in lstTypes"
                            :key="item.id"
                            :label="item.name"
                            :value="item"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="编码">
                    <el-input v-model="formLabel.code" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="所属模块" prop="moduleID">
                    <el-select
                        v-model="formLabel.moduleID"
                        placeholder="请选择所属类目"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in Modules"
                            :key="item.id"
                            :label="item.moduleName"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="财务系统字段">
                    <el-select
                        v-model="formLabel.finFieldNames"
                        placeholder="请选择财务系统字段"
                        style="width: 100%"
                        multiple
                    >
                        <el-option
                            v-for="item in FinFieldList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="业务数据字段">
                    <el-select
                        v-model="formLabel.sourceFieldNames"
                        placeholder="请选择业务数据字段"
                        style="width: 100%"
                        multiple
                    >
                        <el-option
                            v-for="item in SourceFieldList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="formLabel.remark" placeholder=""></el-input>
                </el-form-item>
                <el-form-item label="对应表名">
                    <el-input
                        v-model="formLabel.souceTableName"
                        placeholder="请输入存储对应的表名"
                    ></el-input>
                </el-form-item>
                <el-form-item label="业务数据来源">
                    <el-select
                        v-model="formLabel.sourceDataFieldName"
                        placeholder="请选择业务数据来源"
                        style="width: 100%"
                    >
                        <el-option
                            v-for="item in SourceFieldList"
                            :key="item.name"
                            :label="item.name"
                            :value="item.name"
                        ></el-option>
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="SaveEntity()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import config from "@/common/config.js";
import AjaxHelper from "@/common/js/AjaxHelper";
import pagerBar from "@/views/pager/pagerBar";
export default {
    data() {
        return {
            openloading: true,
            dialogVisible: false, // 弹窗显示
            tableData: [],
            choosedTypes: {},
            lstTypes: [],
            basicDataListUrl: config.BASE_Middle_API + "BasicDatas/GetAll",
            getModulesUrl: config.BASE_Middle_API + "BussinessModule/GetEnableParentData",
            basicDataUrl: config.BASE_Middle_API + "BasicDatas", //基础档案,
            BasicFieldUrl: config.BASE_Middle_API + "BasicFields",
            BusinessModulesUrl: config.BASE_Middle_API + "BussinessModule", //业务模块分类
            deleteUrl: config.BASE_Middle_API + "BasicDatas/Delete",
            lstBusinessModules: [],
            SourceFieldList: [],
            FinFieldList: [],
            Modules: [], //所属类目
            CurrnetIndex: 0,
            title: "新增基础资料",
            operation: "",
            formLabel: {
                id: null,
                name: "",
                moduleID: 0,
                code: "",
            },
            total: 0,
            currentPage: 1,
            pagesize: 10,
            rules: {
                name: [{ required: true, message: "请选择基础资料类别", trigger: "blur" }],
                // ModuleID: [
                //   { required: true, message: "请选择所属类目", trigger: "change" }
                // ],
            },
            formInLine: {
                moduleID: 0,
                Filter: "",
            },
        };
    },
    components: {
        pagerBar,
    },
    mounted() {
        this.formInLine.moduleID = 0;
        this.initBusinessModules();
        this.getModules();
        this.getBasicInfoTypes();
    },
    methods: {
        GetFieldSelect() {
            const _this = this;
            AjaxHelper.get(
                _this.BasicFieldUrl + "/GetFieldsForSelect?moduleID=" + _this.formLabel.moduleID
            )
                .then(function(response) {
                    if (response.success) {
                        _this.SourceFieldList = response.result;
                        _this.FinFieldList = response.result;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },

        getBasicInfoTypes() {
            const _this = this;
            AjaxHelper.get(_this.basicDataUrl + "/GetAllBasicInfoTypes")
                .then(function(response) {
                    if (response.success) {
                        _this.lstTypes = response.result;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        closeOpenloading() {
            this.openloading = false;
        },
        statusSearch(item, index) {
            this.CurrnetIndex = index;
            this.formInLine.moduleID = item.id;
        },
        changeValue(item) {
            this.formLabel.name = item.name;
        },
        //新增基础资料档案
        addInfo() {
            this.dialogVisible = true;
            this.clearformLabel();
            this.title = "新增基础资料";
            this.initModel();
            if (this.formInLine.moduleID == 0) {
                this.formLabel.moduleID = this.Modules[0].id;
            } else {
                this.formLabel.moduleID = this.formInLine.moduleID;
            }
            this.GetFieldSelect();
        },
        clearformLabel() {
            const _this = this;
            _this.formLabel.id = null;
            _this.formLabel.name = "";
            _this.formLabel.moduleID = 0;
            _this.formLabel.code = "";
        },
        //编辑
        editRow(id) {
            const _this = this;
            _this.initModel();
            _this.title = "编辑基础资料";
            _this.operation = "edit";
            _this.getModules();
            let confirmData = { Id: id };

            AjaxHelper.get(_this.basicDataUrl + "/GetBasicDataForEdit", confirmData)
                .then(function(response) {
                    if (response.success) {
                        _this.dialogVisible = true;
                        _this.formLabel = response.result.basicData;
                        if (_this.formLabel.finFields) {
                            _this.formLabel.finFieldNames = [
                                ..._this.formLabel.finFields.split(",").map((x) => {
                                    return x;
                                }),
                            ];
                        }
                        if (_this.formLabel.sourceFields) {
                            _this.formLabel.sourceFieldNames = [
                                ..._this.formLabel.sourceFields.split(",").map((x) => {
                                    return x;
                                }),
                            ];
                        }
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });

            _this.GetFieldSelect();
        },
        deleteEntity(id) {
            const _this = this;
            this.$confirm("此操作将删除该基础资料, 是否继续?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
                center: true,
            })
                .then(() => {
                    let confirmData = { Id: id };
                    AjaxHelper.delete(_this.deleteUrl, confirmData).then(function(response) {
                        if (response.success) {
                            _this.$message({
                                type: "success",
                                message: "删除成功!",
                            });
                            _this.Refresh();
                        }
                    });
                })
                .catch((e) => {
                    _this.$message({
                        type: "info",
                        message: "已取消删除",
                    });
                });
        },
        //保存基础资料档案
        SaveEntity() {
            const _this = this;
            this.$refs["BasicDataEditForm"].validate((valid) => {
                let basicData = {};
                if (_this.operation == "edit") {
                    basicData = _this.formLabel;
                } else {
                    basicData = _this.formLabel;
                }
                if (basicData.finFieldNames) {
                    basicData.finFields = basicData.finFieldNames.join(",");
                }
                if (basicData.finFieldNames) {
                    basicData.sourceFields = basicData.sourceFieldNames.join(",");
                }

                if (valid) {
                    AjaxHelper.post(_this.basicDataUrl + "/CreateOrEdit", basicData).then(function(
                        response
                    ) {
                        if (response.success) {
                            _this.$message({
                                type: "success",
                                message: "操作成功",
                            });
                            _this.pagesize = 1;
                            _this.Refresh();
                            _this.dialogVisible = !_this.dialogVisible;
                        } else {
                            _this.$message({
                                type: "error",
                                message: response.Messages[0],
                            });
                        }
                    });
                    // .catch(function(error) {
                    //   _this.$message({
                    //     type: "error",
                    //     message: error
                    //   });
                    // });
                }
            });
        },
        getModules() {
            const _this = this;
            AjaxHelper.get(_this.getModulesUrl)
                .then(function(response) {
                    if (response.success) {
                        _this.Modules = response.result;
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        initData(d) {
            const _this = this;
            _this.tableData = d;
            _this.openloading = false;
        },
        initBusinessModules() {
            const _this = this;
            AjaxHelper.get(_this.BusinessModulesUrl + "/GetAllParentData")
                .then(function(response) {
                    if (response.success) {
                        _this.lstBusinessModules = response.result;
                        _this.lstBusinessModules.unshift({
                            moduleName: "全部",
                            id: 0,
                        });
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        initModel() {
            if (this.$refs["BasicDataEditForm"]) {
                this.$refs["BasicDataEditForm"].resetFields();
                this.formLabel = {
                    id: null,
                    name: "",
                    moduleID: 0,
                    code: "",
                };
            }
        },
        Refresh() {
            this.$refs.refPagerBar.Refresh();
        },
        handleClose(done) {
            done();
        },
    },
};
</script>

<style scoped="scoped">
dt,
dd {
    margin: 0;
    padding: 0;
}
.el-card {
    height: calc(100vh - 217px) !important;
}
</style>
